export default "__VITE_ASSET__CtxfA5ge__"